import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";
import StripeCheckout from "react-stripe-checkout";
const KEY = "pk_test_51MBxftSCXO0fQKAqhcwVieaO3Q0FB5cHVqmgRtgIcwsky59AOrEvsQSH7WM6ezSU9jhe9A29ZZAVprtNcGcS2K8600cWxdv43o"
const Pay = () =>{
    const [stripeToken , setstripeToken]  = useState(null);
    const onToken = (token)=>{
        setstripeToken(token);
       
    };
    useEffect(()=>{
        const makeRequest = async()=>{
            try{
                const response = await axios.post("https://fashionmania.onrender.com/api/checkout/payment" ,{
                    tokenId:stripeToken.id,
                    amount:2000,

                });
                console.log(response.data);
                
            }catch(err){
                console.log(err);
            }
        }
        stripeToken && makeRequest()
        
    } ,[stripeToken]);
    return (
        <div 
        style ={{
            height:"100vh",
            display:"flex",
            alignItems:"center",
            justifyContent:"center",


        }}
        ><StripeCheckout
            name="FashionMania"
            images=""
            billingAddress
            shippingAddress
            description="Your total is $20"
            amount={2000}
            token={onToken}
            stripeKey={KEY}


        >
            <button
            style ={{
                border:"none",
                width:120,
                borderRadius:5,
                padding:"20px",
                backgroundColor:"black",
                color:"white",
                fontWeight:"600",
                cursor:"pointer"
    
            }}
            >
                Pay NOW
                </button>
                </StripeCheckout>
                </div>
    );

    
};

export default Pay;